import { render, staticRenderFns } from "./UserViewUserTimelineCard.vue?vue&type=template&id=08068938&scoped=true&"
import script from "./UserViewUserTimelineCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserTimelineCard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewUserTimelineCard.vue?vue&type=style&index=0&id=08068938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08068938",
  null
  
)

export default component.exports